import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class CampusLernheft extends MongoEntity {
  public static override _class = 'CampusLernheft';
  public static override _collectionName = 'campus-lernhefte';

  @Field(type => String)
  public title: Maybe<string>;

  override toString() {
    return this.title ?? '';
  }
}
